import Vue from 'vue'
import Vuex from 'vuex'
import modules from '@/store-modules'
// import auth from '@/store-modules/auth.store'
// import supplier from '@/store-modules/supplier.store'
// import stock from '@/store-modules/stock.store'
// import unit from '@/store-modules/unit.store'
// import supplierProduct from '@/store-modules/supplier-product.store'
// import recievedInventory from '@/store-modules/recieved-inventory.store'
// import saleInventory from '@/store-modules/sale-inventory.store'
// import lostInventory from '@/store-modules/lost-inventory.store'
// import websocket from '@/store-modules/websocket.store'
// import settings from '@/store-modules/settings.store'
// import user from '@/store-modules/users.store'
// import consumer from '@/store-modules/consumer.store'
// import consumerLoan from '@/store-modules/consumer-loan.store'
// import consumerLoanInventory from '@/store-modules/consumer-loan-inventory.store'
// import consumerLoanTransaction from '@/store-modules/consumer-loan-transaction.store'
// import branchLocation from '@/store-modules/branch-locations.store'
// import stockTransfer from '@/store-modules/stock-transfer.store'
// import expense from '@/store-modules/expense.store'

Vue.use(Vuex)

function colorIndex (color) {
  const colors = [
    '#9C27b0',
    '#00CAE3',
    '#4CAF50',
    '#ff9800',
    '#E91E63',
    '#FF5252',
  ]

  return colors.findIndex(el => el === color)
}
// const path = __dirname.replace(/file:\/\/\//g, '')
export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require('./extraResources/images/sidebar/sidebar-1.jpg'),
    drawer: null,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_BAR_COLOR (state, payload) {
      state.barColor = `rgba(0, 0, 0, .6), rgba(${payload} .6)`
    },
  },
  actions: {
    // setBarImage ({ commit }, payload) {
    //   if(payload == '') {
    //     commit('SET_BAR_IMAGE', payload)
    //   }
    // },
    setBarColor ({ commit }, payload) {
      const cIndex = colorIndex(payload) + 1
      const colors = [
        '0, 0, 0,',
        '156, 39, 176,',
        '51, 213, 233,',
        '76, 175, 80,',
        '255, 152, 0,',
        '233, 30, 99,',
        '255, 82, 82,',
      ]
      commit('SET_BAR_COLOR', colors[cIndex])
    },
  },
  modules,
  // modules: {
  //   auth,
  //   branchLocation,
  //   supplier,
  //   stock,
  //   unit,
  //   supplierProduct,
  //   recievedInventory,
  //   saleInventory,
  //   lostInventory,
  //   websocket,
  //   settings,
  //   user,
  //   consumer,
  //   consumerLoan,
  //   consumerLoanInventory,
  //   consumerLoanTransaction,
  //   stockTransfer,
  //   expense,
  // },
})
